import React, { Fragment } from 'react'
import Media from 'components/common/Media'
import CompareTrayDesktop from './CompareTrayDesktop'
import CompareTrayMobile from './CompareTrayMobile'

const BOTTireComparePanel = props =>
  <Fragment>
    <Media.Desktop>
      <CompareTrayDesktop { ...props } />
    </Media.Desktop>
    <Media.Mobile>
      <CompareTrayMobile { ...props } />
    </Media.Mobile>
  </Fragment>

export default BOTTireComparePanel
